import React, { Component, Fragment } from "react";
import { withApollo, Query, compose } from "react-apollo";
import { PACKAGES } from "../../store/queries.js";
import { updateUser } from "../../store/redux/actions";

import { SelectionCard, LoadingIndicator, Select } from "../";
import cookie from "js-cookie"
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
const planOrder = ["Daily", "Monthly", "Month to Month", "Yearly"];
function sortPlans(plans) {
  return plans.sort((a, b) => {
    let i1 = planOrder.indexOf(a.name),
      i2 = planOrder.indexOf(b.name);
    if (i1 < 0) i1 = plans.length;
    if (i2 < 0) i2 = plans.length;
    return i1 - i2;
  });
}

function rejectHidden(plans) {
  return plans.filter(p => !p.hidden);
}
function acceptHidden(plans) {
  return plans.filter(p => p.hidden);
}

class PackageSelector extends Component {
  state = {
    selected: null
  };

  componentDidMount() {
    console.log("[PackageSelector] componentDidMount - dogId:", this.props.dogId);
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("[PackageSelector] componentDidUpdate", {
      prevDogId: prevProps.dogId,
      currentDogId: this.props.dogId,
      prevSelected: prevState.selected,
      currentSelected: this.state.selected,
      dogIdChanged: prevProps.dogId !== this.props.dogId
    });
  }

  selectPlan = plan => {
    console.log("[PackageSelector] selectPlan called with:", { planId: plan.id, planName: plan.name, recurring: plan.recurring });
    this.props.onChange(plan);
    this.setState({ selected: plan.id });
  };

  render() {
    const { selected } = this.state;
    const { width, height, hiddenPackages, dogId } = this.props;

    console.log("[PackageSelector] render() - dogId:", dogId, "selected:", selected, "hiddenPackages:", hiddenPackages);
    let variables = {
      showHidden: !!hiddenPackages,
      dogId: dogId
    };
    console.log("[PackageSelector] Query variables:", variables);
    return (
      <Fragment>
        <Query fetchPolicy="no-cache" query={PACKAGES} variables={variables}>
          {({ loading, error, data, refetch }) => {
            console.log("[PackageSelector] Query callback", {
              loading,
              hasError: !!error,
              errorMsg: error?.message,
              hasData: !!data,
              packagesCount: data?.packages?.length
            });

            if (loading) {
              console.log("[PackageSelector] Rendering LoadingIndicator");
              return <LoadingIndicator {...{ width, height, loading }} />;
            } else  if (error) {
              console.log("[PackageSelector] Error occurred:", error.message);
              if (
                error?.message ===
                "GraphQL error: You are not authorized to access that resource"
              ) {
                cookie.remove("token");
                this.props.updateUser("reset");
                // localStorage.clear()
                this.props.history.push("/login");
              }
              return <p>{`Error: ${error?.message}`}</p>;
            } else if (data?.packages) {
              const customerPlans = sortPlans(rejectHidden(data?.packages));
              const hiddenPlans = acceptHidden(data?.packages);
              const selectedHiddenPlan = hiddenPlans.find(
                p => p.id === selected
              );
              console.log("[PackageSelector] Rendering packages", {
                totalPackages: data.packages.length,
                customerPlansCount: customerPlans.length,
                hiddenPlansCount: hiddenPlans.length,
                selectedHiddenPlan: selectedHiddenPlan?.name
              });
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    maxWidth: "780px",
                    margin: "3em auto"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      flexWrap: "wrap"
                    }}
                  >
                    {customerPlans.map((pack, index) => (
                      <SelectionCard
                        key={index}
                        height={height}
                        width={width}
                        recurence={pack.name}
                        price={pack.amountString}
                        description={pack.description}
                        recurring={pack.recurring}
                        selected={selected === pack.id}
                        onClick={() => this.selectPlan(pack)}
                      />
                    ))}
                  </div>
                  {hiddenPackages && hiddenPlans.length > 0 && (
                    <label
                      htmlFor="hidden-plans"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      Other Plans:
                      <Select
                        containerStyle={{ margin: 5 }}
                        options={hiddenPlans}
                        handleSelect={this.selectPlan}
                        name="hiddenPlan"
                        selected={
                          (selectedHiddenPlan && selectedHiddenPlan.name) || ""
                        }
                        width={300}
                        height={height / 25}
                      />
                    </label>
                  )}
                </div>
              );
            }
          }}
        </Query>
      </Fragment>
    );
  }
}

const mapDispatchToProps = { updateUser };

export default compose(
  withApollo,
  withRouter,
  connect(null, mapDispatchToProps)
)(PackageSelector);

// export default withApollo(PackageSelector);
